import { jwtDecode } from "jwt-decode";

export const AUTH_TOKEN_KEY = "auth_token";
export const AUTH_CHANGED_EVENT = "stylisher:auth-changed";
export const SESSION_EXPIRED_EVENT = "stylisher:session-expired";

// Decoding is only for the UI's expiry check. The backend verifies the signature.
export function getSessionUser(token) {
  if (!token) return null;
  try {
    const user = jwtDecode(token);
    return typeof user.exp === "number" && Number.isFinite(user.exp) &&
      user.exp * 1000 > Date.now() ? user : null;
  } catch {
    return null;
  }
}

// Read the admin claim even after expiry so only admins receive the login redirect.
export function isAdminSession(token) {
  if (!token) return false;
  try {
    return jwtDecode(token)?.isAdmin === true;
  } catch {
    return false;
  }
}

export function setAuthToken(token) {
  if (token) localStorage.setItem(AUTH_TOKEN_KEY, token);
  else localStorage.removeItem(AUTH_TOKEN_KEY);
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}

export function expireSession(token) {
  // An old in-flight request must not clear a newer login.
  if (!token || localStorage.getItem(AUTH_TOKEN_KEY) !== token) return;
  const wasAdmin = isAdminSession(token);
  setAuthToken(null);
  if (wasAdmin) window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
}

export function getAuthToken() {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (token && !getSessionUser(token)) {
    expireSession(token);
    return null;
  }
  return token;
}
